const LOCALES = { EN: "en-GB", FR: "fr-FR", IT: "it-IT" };

export const formatLegalDate = (iso, lang) => {
  const d = new Date(iso + "T00:00:00");
  return new Intl.DateTimeFormat(LOCALES[lang] || "en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(d);
};
